import * as React from 'react';
import { DataHooks } from '@src/constants/data-hooks';
import { DrillInSection } from '../../drill-in-section/drill-in-section';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { ResetLogPrompt } from './reset-log-prompt';
import { AppContext } from '@src/context/store';
import { sendBIAdvancedOptionsCTA, AdvancedOptionsCTA } from '@src/context/actions/bi';
import { ToastType } from '@wix/business-manager-api';

export const ResetLogSection = translate()(({ t }: InjectedTranslateProps) => {
  const { resetExpiryDate: resetLogs, showToast } = React.useContext(AppContext);
  const [isModalOpened, updateModalOpen] = React.useState(false);
  const closeModal = () => updateModalOpen(false);
  const openModal = () => {
    sendBIAdvancedOptionsCTA(AdvancedOptionsCTA.ResetConsentLog);
    updateModalOpen(true);
  };

  const onApproveResetLogs = async () => {
    try {
      await resetLogs();
      showToast({
        biName: 'consent-policy',
        message: t('advanced-options.reset-log.success'),
        type: ToastType.SUCCESS,
      });
    } catch (e) {
      showToast({
        biName: 'consent-policy',
        message: t('advanced-options.reset-log.error'),
        type: ToastType.ERROR,
      });
    }
    closeModal();
  };

  return (
    <>
      <DrillInSection
        dataHook={DataHooks.ResetLogSection}
        title={t('advanced-options.reset-log.title')}
        subtitle={t('advanced-options.reset-log.subtitle')}
        buttonText={t('advanced-options.reset-log.drill')}
        onDrillIn={openModal}
      />
      <ResetLogPrompt isOpen={isModalOpened} onOk={onApproveResetLogs} onCancel={closeModal} />
    </>
  );
});
